module.exports = __webpack_public_path__ + "static/img/portal-step3.b39247a.png";


//////////////////
// WEBPACK FOOTER
// ./static/enrol/portal-step3.png
// module id = azY9
// module chunks = 170